<template>
  <div class="container-fluid container-with-vertical-nav full-height cards-pf">
    <div class="row row-cards-pf">
      <div class="col-xs-12">
        <div class="card-pf">
          <div class="card-pf-heading">
            <h2 class="card-pf-title">สร้างหน่วยงาน</h2>
          </div>
          <div class="card-pf-body">
            <form action="/" class="form-horizontal">
              <div class="form-group">
                <label class="col-sm-3 control-label required-field">ชื่อหน่วยงาน</label>
                <div class="col-sm-8">
                  <input v-model="name" type="text" class="form-control">
                </div>
              </div>
              <div class="form-group">
                <label class="col-sm-3 control-label required-field">สังกัต</label>
                <div class="col-sm-8">
                  <input v-model="department" type="text" class="form-control">
                </div>
              </div>
              <div class="form-group">
                <label class="col-sm-3 control-label required-field">ประเภท</label>
                <div class="col-sm-8">
                  <select v-model="type" class="selectpicker">
                    <option>ชุมนุม</option>
                    <option>ชมรม</option>
                    <option>สโมสร</option>
                  </select>
                </div>
              </div>
              <div class="form-group">
                <label class="col-sm-3 control-label required-field">ประธาน</label>
                <div class="col-sm-8">
                  <input v-model="cheifName" type="text" class="form-control">
                </div>
              </div>
              <div class="form-group">
                <label class="col-sm-3 control-label required-field">อาจารย์ที่ปรึกษา</label>
                <div class="col-sm-8">
                  <input v-model="advisorName" type="text" class="form-control">
                </div>
              </div>
              <div class="form-group">
                <div class="col-sm-8 col-sm-offset-3">
                  <button class="btn btn-primary" @click.prevent="submit">บันทึก</button>
                  <router-link :to="{ name: 'settings.groups.index' }" class="btn btn-default">ยกเลิก</router-link>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import gql from 'graphql-tag'

export default {
  apollo: {
    //
  },
  data () {
    return {
      name: '',
      type: '',
      department: '',
      cheifName: '',
      advisorName: ''
    }
  },
  methods: {
    async submit () {
      const group = await this.$apollo.mutate({
        mutation: gql`mutation ($group: CreateGroupInput!) {
          createGroup(group: $group) {
            _id
          }
        }`,
        variables: {
          group: {
            name: this.name,
            department: this.department,
            type: this.type,
            cheifName: this.cheifName,
            advisorName: this.advisorName
          }
        }
      })

      // TODO: Implement toast notification

      this.$router.push({ name: 'settings.groups.show', params: { id: group.data.createGroup._id } })
    }
  }
}
</script>

<style lang="sass" scoped>
//
</style>



// WEBPACK FOOTER //
// src/js/views/settings/groups/Create.vue